import React, { useState, useEffect } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { IonContent, IonPage, IonSelectOption, IonSelect, IonDatetime, IonItem, IonButton, useIonToast } from "@ionic/react";

import Header from "src/components/Header";
import PanelFiscalizacion from "src/components/Fiscalizacion/PanelFiscalizacion";
import "./Fiscalizacion.css";
import { dateAFormatoGlobal, diaSiguiente } from "src/utils/fechas";
import { ICalificaciones, IMedidasCorrectivas, IPostDeposito, fetchCalificaciones, fetchDeposito, fetchMedidasCorrectivas, postDeposito } from "src/services/Fiscalizacion/Deposito";
import ComentarioFiscalizacion from "src/components/Fiscalizacion/ComentarioFiscalizacion";
import { useFiscalizacion } from "src/components/Fiscalizacion/FiscalizacionContext";

const CALIFICACIONES_DEPOSITO_ORDEN = [1, 8, 2, 3, 4];

const etiquetaCalificacionDeposito = (calificacion?: ICalificaciones | null) => {
    if (!calificacion) {
        return '';
    }
    return calificacion.id === 4 ? 'Deficiente' : calificacion.calificacion;
};

const FiscalizarDesposito = ({ history }:RouteComponentProps) => {
    const { setInformacionFiscalizacionDeposito } = useFiscalizacion(); 
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [calificaciones, setCalificaciones] = useState<ICalificaciones[]>([]);
    const [depositoId, setDepositoId] = useState<number | null>(null);
    const [calificacion, setCalificacion] = useState<number | null>(null);
    const [medidasCorrectivas, setMedidasCorrectivas] = useState<IMedidasCorrectivas[]>([]);
    const [medidaCorrectivaSeleccionada, setMedidaCorrectivaSeleccionada] = useState<number | null>(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [present] = useIonToast();
    const tomorrow = diaSiguiente(new Date());
    const minDate = dateAFormatoGlobal(tomorrow);

    useEffect(() => {
        const cargarDatosIniciales = async () => {
            const resCalificaciones = await fetchCalificaciones();
            const resMedidas = await fetchMedidasCorrectivas();
    
            if (resCalificaciones.datos) {
                const calificacionesDeposito = CALIFICACIONES_DEPOSITO_ORDEN
                    .map((id) =>
                        resCalificaciones.datos.find((item) => item.id === id)
                    )
                    .filter(Boolean) as ICalificaciones[];
                setCalificaciones(calificacionesDeposito);
            }
    
            if (resMedidas.datos) {
                setMedidasCorrectivas(resMedidas.datos.flat());
            }
        };
    
        cargarDatosIniciales();
    }, []);
    
    useEffect(() => {
        const cargarDatosDeposito = async () => {
            const { pathname } = history.location;
            const params = pathname.split("/");
            const fiscalizacionId = parseInt(params[5]);
            if (!isNaN(fiscalizacionId)) {
                const depositoData = await fetchDeposito(fiscalizacionId);
                if (depositoData.datos.length > 0) {
                    const deposito = depositoData.datos[0];
                    if (calificaciones.length > 0 && deposito.calificacion?.trim()) {
                        const calificacionMatch = calificaciones.find(
                            (cal) => {
                                const valorActual = deposito.calificacion!.trim().toLowerCase();
                                return (
                                    cal.calificacion.trim().toLowerCase() === valorActual ||
                                    etiquetaCalificacionDeposito(cal).trim().toLowerCase() === valorActual
                                );
                            }
                        );
                        setCalificacion(calificacionMatch ? calificacionMatch.id : null);
                    }
                    setDepositoId(deposito.id);
                    setMedidaCorrectivaSeleccionada(deposito.medida_correctiva_id ?? null);
                    setSelectedDate(deposito.plazo ?? "");
                }
            }
        };
    
        if (calificaciones.length > 0) {
            cargarDatosDeposito();
        }
    }, [history.location, calificaciones]); 
    
    
    const formatDate = (isoDate) => {
        if (!isoDate) return '';
    
        const date = new Date(isoDate);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
    
        return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    };
    

    const handleDateChange = (e: CustomEvent) => {
        setSelectedDate(e.detail.value);
    };

    const handleCalificacionChange = (e: CustomEvent) => {
        setCalificacion(e.detail.value);
    };

    const handleMedidasCorrectivasChange = (e: CustomEvent) => {
        setMedidaCorrectivaSeleccionada(Number(e.detail.value));
    };

    const guardarDeposito = async () => {
        setIsSubmitted(true);

        const formattedDate = formatDate(selectedDate);
        
        if (!calificacion) {
            present('Dar una calificación al Deposito', 3000);
            return; 
        }
        
        if (calificacion === 4 && (!medidaCorrectivaSeleccionada || !selectedDate) ) {
            present('Todos los campos son obligatorios', 3000);
            return; 
        }
        
        const despositoData: IPostDeposito = {
            calificacion_id: +calificacion!,
            medida_correctiva_id: medidaCorrectivaSeleccionada ?? null,
            plazo_implementacion: formattedDate === '' ? null : formattedDate,
            deposito_id: depositoId || null,
        };
        const calificacionSeleccionada = calificaciones.find(
            (item) => item.id === Number(calificacion)
        );
        setInformacionFiscalizacionDeposito({
            ...despositoData,
            calificacion: etiquetaCalificacionDeposito(calificacionSeleccionada),
        })
        const { pathname } = history.location;
        const params = pathname.split('/');
    
        // El fiscalizacion_id se encuentra en la posición 3 del array params
        const fiscalizacion_id = params[5];
        const resultado = await postDeposito(parseInt(fiscalizacion_id), despositoData);
       
        if (resultado.exito) {
            present('Formulario guardado con éxito', 3000);
            history.goBack()
        } else {
            present(resultado.mensaje ?? "Ocurrió un error", 3000);
        }
        
    };
    return (
        <IonPage>
            <Header titulo="Fiscalización - Desposito" />

            <IonContent id="fiscalizacion">
            <div className="fisContainer">

                <PanelFiscalizacion />
                
                <div className="fisCard">
                    <div className="fisCard_title--area">
                        <img src="assets/icon/fisc-COD2.svg" alt="personal" />
                        <h1>Deposito</h1>
                    </div>
                    <IonSelect 
                        placeholder="Califica el Deposito" 
                        interface="action-sheet"
                        value={calificacion}
                        onIonChange={handleCalificacionChange}
                        className={isSubmitted && !calificacion ? 'campo-obligatorio' : ''}
                    >
                        {calificaciones.map((cal) => (
                            <IonSelectOption key={cal.id} value={cal.id}>
                                {etiquetaCalificacionDeposito(cal)}
                            </IonSelectOption>
                        ))}
                    </IonSelect>

                    {calificacion === 4 && (
                        <>
                            <h4>Medidas Correctivas</h4>
                            <IonSelect                             
                                placeholder="Medidas Correctivas"
                                interface="action-sheet"
                                onIonChange={handleMedidasCorrectivasChange}
                                className={isSubmitted && !medidaCorrectivaSeleccionada ? 'campo-obligatorio' : ''}
                            >
                                {medidasCorrectivas.map((medida) => (
                                    <IonSelectOption key={medida.id} value={medida.id.toString()}>{medida.descripcion}</IonSelectOption>
                                ))}
                            </IonSelect>
                            <h4>Plazo de Implementacion</h4>
                            <IonItem>
                                <IonDatetime
                                displayFormat="DD/MM/YYYY" 
                                placeholder="Selecciona una fecha"
                                value={selectedDate} 
                                onIonChange={handleDateChange} 
                                className={isSubmitted && !selectedDate ? 'campo-obligatorio' : ''}
                                />
                            </IonItem>
                        </>
                    )}
                 <IonButton onClick={guardarDeposito}>Guardar</IonButton>
                </div>
                <ComentarioFiscalizacion/>
            </div>
            
            
            </IonContent>
        </IonPage>
    );
};

export default withRouter(FiscalizarDesposito);
